export default {
  name: 'bs',
  el: {
    breadcrumb: {
      label: 'Putokaz',
    },
    colorpicker: {
      confirm: 'U redu',
      clear: 'Očisti',
      defaultLabel: 'birač boja',
      description: 'trenutna boja je {color}. pritisnite enter za odabir nove boje.',
      alphaLabel: 'odaberite alfa vrijednost',
    },
    datepicker: {
      now: 'Sada',
      today: 'Danas',
      cancel: 'Otkaži',
      clear: 'Očisti',
      confirm: 'U redu',
      dateTablePrompt: 'Koristite strelice i enter za odabir dana u mjesecu',
      monthTablePrompt: 'Koristite strelice i enter za odabir mjeseca',
      yearTablePrompt: 'Koristite strelice i enter za odabir godine',
      selectedDate: 'Odabrani datum',
      selectDate: 'Izaberite datum',
      selectTime: 'Izaberite vrijeme',
      startDate: 'Datum početka',
      startTime: 'Vrijeme početka',
      endDate: 'Datum završetka',
      endTime: 'Vrijeme završetka',
      prevYear: 'Prethodna godina',
      nextYear: 'Sljedeće godine',
      prevMonth: 'Prethodni mjesec',
      nextMonth: 'Sljedeći mjesec',
      year: '',
      month1: 'Januar',
      month2: 'Februar',
      month3: 'Mart',
      month4: 'April',
      month5: 'Možda',
      month6: 'Juni',
      month7: 'Juli',
      month8: 'Avgust',
      month9: 'Septembar',
      month10: 'Oktobar',
      month11: 'Novembar',
      month12: 'Decembar',
      week: 'tjedan',
      weeks: {
        sun: 'Sun',
        mon: 'Pon',
        tue: 'Uto',
        wed: 'Srijeda',
        thu: 'Čet',
        fri: 'Pet',
        sat: 'Sat',
      },
      weeksFull: {
        sun: 'Nedjelja',
        mon: 'Ponedjeljak',
        tue: 'Utorak',
        wed: 'Srijeda',
        thu: 'Četvrtak',
        fri: 'Petak',
        sat: 'Subota',
      },
      months: {
        jan: 'Јан',
        feb: 'феб',
        mar: 'Mar',
        apr: 'Apr',
        may: 'Možda',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Okt',
        nov: 'Nov',
        dec: 'Dec',
      },
    },
    inputNumber: {
      decrease: 'smanji broj',
      increase: 'Povećaj broj',
    },
    select: {
      loading: 'Učitavanje',
      noMatch: 'Nema podudarnih podataka',
      noData: 'Nema podataka',
      placeholder: 'Izaberi',
    },
    mention: {
      loading: 'Učitavanje',
    },
    dropdown: {
      toggleDropdown: 'Prebaci padajući meni',
    },
    cascader: {
      noMatch: 'Nema podudarnih podataka',
      loading: 'Učitavanje',
      placeholder: 'Odaberite',
      noData: 'Nema podataka',
    },
    pagination: {
      goto: 'Idi na',
      pagesize: '/stranica',
      total: 'Ukupno {total}',
      pageClassifier: '',
      page: 'Stranica',
      prev: 'Idi na prethodnu stranicu',
      next: 'Idi na sljedeću stranicu',
      currentPage: 'stranica {pager}',
      prevPages: 'Prethodnih {pager} stranica',
      nextPages: 'Sljedeće {pager} stranice',
      deprecationWarning: 'Otkrivena je zastarjela upotreba, molimo pogledajte dokumentaciju za el-pagination za više detalja',
    },
    dialog: {
      close: 'Zatvori ovaj dijalog',
    },
    drawer: {
      close: 'Zatvori ovaj dijalog',
    },
    messagebox: {
      title: 'Poruka',
      confirm: 'U redu',
      cancel: 'Otkaži',
      error: 'Nedozvoljen unos',
      close: 'Zatvori ovaj dijalog',
    },
    upload: {
      deleteTip: 'pritisnite delete za uklanjanje',
      delete: 'Izbriši',
      preview: 'Pregled',
      continue: 'Nastavi',
    },
    slider: {
      defaultLabel: 'klizač između {min} i {max}',
      defaultRangeStartLabel: 'odaberite početnu vrijednost',
      defaultRangeEndLabel: 'odaberite krajnju vrijednost',
    },
    table: {
      emptyText: 'Nema podataka',
      confirmFilter: 'Potvrditi',
      resetFilter: 'Resetuj',
      clearFilter: 'Sve',
      sumText: 'Suma',
    },
    tour: {
      next: 'Sljedeće',
      previous: 'Prethodno',
      finish: 'Završi',
    },
    tree: {
      emptyText: 'Nema podataka',
    },
    transfer: {
      noMatch: 'Nema podudarnih podataka',
      noData: 'Nema podataka',
      titles: ['Lista 1', 'Lista 2'],
      filterPlaceholder: 'Unesite ključnu riječ',
      noCheckedFormat: '{total} stavki',
      hasCheckedFormat: '{checked}/{total} provjereno',
    },
    image: {
      error: 'NEUSPJELI',
    },
    pageHeader: {
      title: 'Nazad',
    },
    popconfirm: {
      confirmButtonText: 'Da',
      cancelButtonText: 'Ne',
    },
    carousel: {
      leftArrow: 'Strelica karusela lijevo',
      rightArrow: 'Strelica karusela desno',
      indicator: 'Karusel prebaci na indeks {index}',
    },
  },
}
